import { QueryKeys } from '../../../enums/queryKeys'
import { TransactionSortProperty } from '../../transactions/enums/transactionSortProperty'
import { TransactionsQueryProps } from '../../transactions/types/transactionsQueryProps'
import { getTransactionsQueryKey } from '../../transactions/utils/getTransactionsQueryKey'

interface BillTransactionsQueries {
  queryKey: [QueryKeys, TransactionsQueryProps]
  queryProps: TransactionsQueryProps
}

export const getBillTransactionsQueries = (billId: string): BillTransactionsQueries => {
  const queryProps: TransactionsQueryProps = {
    originatorReference: `bill:${billId}`,
    sortProperty: TransactionSortProperty.TransactionNo,
    withVoided: true,
  }

  return {
    queryKey: getTransactionsQueryKey(queryProps),
    queryProps,
  }
}
